import { Navigate, Route, Routes } from "react-router-dom";

import {
  PlannerDashboard,
  EventsPage,
  ClientsPage,
  OrganizationPage,
  HelpPage,
  CreateEventPage,
  EventDetailsPage,
} from "../../pages/planner";

export const PlannerRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<PlannerDashboard />} />
      <Route path="/events" element={<EventsPage />} />
      <Route path="/events/create" element={<CreateEventPage />} />
      <Route path="/event/:id" element={<EventDetailsPage />} />
      <Route path="/clients" element={<ClientsPage />} />
      <Route path="/organization" element={<OrganizationPage />} />
      <Route path="/help" element={<HelpPage />} />

      <Route path="*" element={<Navigate to="/planner" />} />
    </Routes>
  );
};
